<template>
    <div class="box">
        <canvas width="1006" height="674" ref="crp"></canvas>
    </div>
</template>
<script>
  import "cropper/dist/cropper.css";
  import Cropper from "cropperjs";
  
  export default {
    props: {
      largeImgage: String,
    },
    data() {
      return {
        cropper: "",
      }
    },
    async mounted() {
      this.$nextTick(() => {
        this.drawImage(this.largeImgage);
      });
    },
    methods: {
      // 画图片方法
      drawImage(src) {
        this.$nextTick(() => {
          let img = new Image();
          // 设置跨域必须放到img.src前面
          img.setAttribute("crossOrigin", "anonymous");
          img.src = src;
          const that = this;
          new Promise((resolve, reject) => {
            img.onload = () => {
              let whRatio = img.width / img.height;
              if (img.width / img.height < 1006 / 674) {
                // 适配高度
                img.height = 674;
                img.width = whRatio * img.height;
              } else {
                // 适配宽度
                img.width = 1006;
                img.height = img.width / whRatio;
              }
              const myCanvas = that.$refs.crp;
              resolve(myCanvas);
            };
          }).then(data => {
            let ctx = data.getContext("2d");
            ctx.clearRect(0, 0, 1006, 674);
            let offsetLeft = 1006 - img.width;
            let offsetHeight = 674 - img.height;
            ctx.drawImage(
              img,
              offsetLeft / 2,
              offsetHeight / 2,
              img.width,
              img.height
            );
            if (that.cropper === "") {
              that.cropper = new Cropper(data, {
                guides: false,
                autoCrop: false,
                background: false,
                zoomable: true,
                toggleDragModeOnDblclick: false,
                ready() {
                  // that.cropper.disable();
                  that.cropper.setDragMode('move');
                }
              });
            } else {
              that.cropper.destroy();
              that.cropper = null;
              that.cropper = new Cropper(data, {
                guides: false,
                autoCrop: false,
                background: false,
                zoomable: true,
                toggleDragModeOnDblclick: false,
                ready() {
                  // that.cropper.disable();
                  that.cropper.setDragMode('move');
                }
              });
            }
          });
        });
      },
      moveHandler() {
        this.cropper.setDragMode('move');
      },
    },
    watch: {
      largeImgage() {
        this.$nextTick(() => {
          this.drawImage(this.largeImgage);
        });
      },
    },
  };
</script>
<style scoped lang="less">
    /*
        修改滚动条样式
    */
    /*::-webkit-scrollbar {*/
        /*width: 5px;*/
        /*height: 100%;*/
    /*}*/
    
    /*::-webkit-scrollbar-track-piece {*/
        /*background: #fff;*/
        /*-webkit-border-radius: 6px;*/
    /*}*/
    
    /*::-webkit-scrollbar-thumb:vertical {*/
        /*background-color: #61a2bf;*/
        /*-webkit-border-radius: 6px;*/
    /*}*/
    
    .box,
    .rightImgEditor,
    .optionWrapper,
    .leftImgList {
        display: flex;
        justify-content: flex-start;
        flex-direction: row;
        align-items: center;
        flex-wrap: nowrap;
    }
    
    .returnClass,
    .saveClass {
        cursor: pointer;
        background: #fff;
        width: 120px;
        height: 20px;
        padding: 10px 0;
        margin-right: 10px;
        right: 20px;
        top: 10px;
        text-align: center;
        line-height: 20px;
        border-radius: 10px;
    }
    
    .to-origin {
        display: block;
        text-decoration: none;
        color: #606266;
    }
    
    .to-origin:active {
        color: #606266;
    }
    
    .to-origin:focus {
        color: #606266;
    }
    
    .to-origin:visited {
        color: #606266;
    }
    
    .returnClass {
        position: absolute;
    }
    
    .box {
        width: 100%;
        height: 100%;
        background-color: #000;
    }
</style>


